var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.toolbarStore.inputCatcherActive && _setup.toolbarStore.inputCatcherEnabled)?_c('div',{ref:"inputCatcher",staticClass:"input-catcher",style:(_setup.style)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }